"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
var api_1 = require("@react-google-maps/api");
var react_1 = __importStar(require("react"));
var chroma_js_1 = __importDefault(require("chroma-js"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../..");
var MapWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 400px; // Adjust the height as needed\n"], ["\n  width: 100%;\n  height: 400px; // Adjust the height as needed\n"])));
function getPerceivedColor(hsla) {
    var color = (0, chroma_js_1.default)(hsla);
    var hue = color.get("hsl.h");
    var lightness = color.get("hsl.l");
    var dominantColor = "";
    if (hue <= 30 || hue > 330) {
        dominantColor = "red";
    }
    else if (hue > 30 && hue <= 90) {
        dominantColor = "yellow";
    }
    else if (hue > 90 && hue <= 150) {
        dominantColor = "green";
    }
    else if (hue > 150 && hue <= 210) {
        dominantColor = "cyan";
    }
    else if (hue > 210 && hue <= 270) {
        dominantColor = "blue";
    }
    else if (hue > 270 && hue <= 330) {
        dominantColor = "magenta";
    }
    var perceivedBrightness = lightness < 0.5 ? "dark" : "light";
    return "".concat(perceivedBrightness, " ").concat(dominantColor);
}
var Map = function (_a) {
    var path = _a.path, manual = _a.manual, _b = _a.clickable, clickable = _b === void 0 ? false : _b, Expand = _a.Expand;
    var _c = (0, __1.useEloise)(), logic = _c.logic, theme = _c.theme;
    var _d = (0, react_1.useState)([]), locations = _d[0], setLocations = _d[1];
    var _e = (0, react_1.useState)({
        lat: 40.712776,
        lng: -74.005974,
    }), center = _e[0], setCenter = _e[1];
    var _f = (0, react_1.useState)(10), zoom = _f[0], setZoom = _f[1];
    var mapRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var listings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!path) return [3 /*break*/, 2];
                        return [4 /*yield*/, logic.fb.docs.getUserCollection(path)];
                    case 1:
                        listings = _a.sent();
                        setLocations(listings.map(function (listing) { return listing.data; }));
                        return [3 /*break*/, 3];
                    case 2:
                        if (manual) {
                            console.log(manual);
                            setLocations(manual);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, [logic]);
    console.log("testingsss");
    var onMapLoad = react_1.default.useCallback(function (map) {
        mapRef.current = map;
    }, []);
    (0, react_1.useEffect)(function () {
        if (locations.length > 0 && mapRef.current) {
            var bounds_1 = new window.google.maps.LatLngBounds();
            locations.forEach(function (location) {
                if (location.addy) {
                    bounds_1.extend({ lat: location.addy.lat, lng: location.addy.lng });
                }
            });
            mapRef.current.fitBounds(bounds_1);
        }
    }, [locations]);
    function assignThemeColors(theme) {
        var themeColors = {
            primary: (0, chroma_js_1.default)(theme.colors[0]),
            secondary: (0, chroma_js_1.default)(theme.colors[1]),
            accent: (0, chroma_js_1.default)(theme.colors[2]),
        };
        var perceivedColors = {
            primary: getPerceivedColor(logic.color.convertToHSLA(theme.colors[0])),
            secondary: getPerceivedColor(logic.color.convertToHSLA(theme.colors[1])),
            accent: getPerceivedColor(logic.color.convertToHSLA(theme.colors[2])),
        };
        var mapColors = {
            water: null,
            roadsHighway: null,
            roadsArterial: null,
            roadsLocal: null,
            parks: null,
            transit: null,
            poi: null,
            administrative: null,
            landscape: null,
        };
        // Assign theme colors to appropriate features
        for (var color in perceivedColors) {
            var colorKey = color;
            switch (perceivedColors[color]) {
                case "light blue":
                case "dark blue":
                    mapColors.water = themeColors[colorKey];
                    break;
                case "light green":
                case "dark green":
                    mapColors.parks = themeColors[colorKey];
                    mapColors.landscape = themeColors[colorKey];
                    break;
                case "light red":
                case "dark red":
                case "light yellow":
                case "dark yellow":
                    mapColors.roadsHighway = themeColors[colorKey].darken().saturate();
                    mapColors.roadsArterial = themeColors[colorKey]
                        .darken(1.5)
                        .saturate();
                    mapColors.roadsLocal = themeColors[colorKey].darken(2).saturate();
                    break;
                // Add more cases as needed
                // default:
                // default color assignment
            }
        }
        // Generate new colors for remaining features
        for (var feature in mapColors) {
            var colorKey = feature;
            if (!mapColors[colorKey]) {
                mapColors[colorKey] = chroma_js_1.default.mix(themeColors.primary, themeColors.secondary, 0.5, "lab");
            }
        }
        return mapColors;
    }
    var adjustedColors = assignThemeColors(theme);
    var mapStyles = [
        {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: adjustedColors.landscape.hex() }],
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: adjustedColors.roadsHighway.hex() }],
        },
        {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: adjustedColors.roadsArterial.hex() }],
        },
        {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [{ color: adjustedColors.roadsLocal.hex() }],
        },
        {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: adjustedColors.parks.hex() }],
        },
        // ... add more features as required
    ];
    var _g = (0, react_1.useState)(null), selectedLocation = _g[0], setSelectedLocation = _g[1];
    (0, react_1.useEffect)(function () {
        console.log(locations);
    }, [locations]);
    return (react_1.default.createElement("div", { className: "p-3" },
        react_1.default.createElement(MapWrapper, null,
            react_1.default.createElement(api_1.GoogleMap, { onLoad: onMapLoad, mapContainerStyle: {
                    width: "100%",
                    height: "100%",
                }, center: center, zoom: zoom, options: {
                    styles: mapStyles,
                    mapTypeControl: false,
                    streetViewControl: false,
                } }, locations.map(function (location, index) {
                return location.addy ? (react_1.default.createElement(api_1.Marker, { key: index, position: {
                        lat: location.addy.lat,
                        lng: location.addy.lng,
                    }, onClick: clickable
                        ? function () {
                            setSelectedLocation(location);
                        }
                        : undefined }, clickable && selectedLocation === location && Expand && (react_1.default.createElement(api_1.InfoWindow, { position: {
                        lat: location.addy.lat,
                        lng: location.addy.lng,
                    }, onCloseClick: function () {
                        setSelectedLocation(null);
                    } }, react_1.default.createElement(Expand, { location: location }))))) : (react_1.default.createElement(react_1.default.Fragment, null));
            })))));
};
exports.Map = Map;
var templateObject_1;
